import { Component, inject } from '@angular/core';
import { MkdeAlertHolderDirective } from './mkde-alert-holder.directive';
import { JsonPipe } from '@angular/common';
import { keysToTranslate } from '@core/util/keys-to-translate';
import { MkdeAlertComponent } from './mkde-alert.component';
import { FormControlComponent } from '../form/form-control.component';
import { FormsModule } from '@angular/forms';

/**
 * Displays the alerts of the enclosing AlertHolder.
 */
@Component({
  selector: 'app-mkde-alert-list',
  template: `
    @for (alert of alertHolder.alerts; track alert) {
      <app-mkde-alert [type]="alert.type" (dismiss)="alertHolder.dismiss(alert)">
        {{ alert.message }}
        @if (alert.type === 'danger' && alert.error) {
          <div style="margin-top:20px">
            <form-control labelKey="Alert.Error">
              <textarea name="error" rows="4" [ngModel]="getErrorString(alert.error)"></textarea>
            </form-control>
          </div>
        }
      </app-mkde-alert>
    }
  `,
  imports: [MkdeAlertComponent, FormControlComponent, FormsModule],
})
export class MkdeAlertListComponent {
  protected alertHolder = inject(MkdeAlertHolderDirective);
  protected jsonPipe = inject(JsonPipe);

  public constructor() {
    keysToTranslate(['Alert.Error']);
  }

  public getErrorString(error: any): string {
    try {
      return this.jsonPipe.transform(error);
    } catch {
      return error;
    }
  }
}
